module.exports = __webpack_public_path__ + "static/media/blackCabDriver.d1a8f09e.jpg";